//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import React, { useRef, useState, useEffect, useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Offcanvas from 'react-bootstrap/Offcanvas';
import Button from 'react-bootstrap/Button'

import { BootstrapIcon } from "../BootstrapIcon"
import { Form, FormSubmit, FormReset, Radio } from '../../common/form-helpers';
import { Guests } from './Guests';
import { useAuth } from '../../auth';
import { eventDateString, eventMarkup } from '../../common/misc';

import { waiver } from './waiver.js';
import * as choiceApi from '../../api/choice';

import './EditReservation.scss';
import { Collapse } from 'react-bootstrap';



function getTypeList(user) {
    let typeList = [];

    if (user.typeId === choiceApi.MEMBERSHIP_TYPE_COUPLE) { //TODO: need to fix up the fields coming back from the database - these are int's and have underscores currently
        //const memberName = user.members.map((x) => x.firstName).join(' & ');
        typeList.push({ value: choiceApi.RESERVATION_TYPE_COUPLE, text: "Couple" });

        user.members.forEach((member) => {
            const resType = member.genderId === choiceApi.GENDER_FEMALE ? choiceApi.RESERVATION_TYPE_FEMALE : choiceApi.RESERVATION_TYPE_MALE;
            typeList.push({ value: resType, text: member.nickname });
        })
    }
    else {
        user.members.forEach((member) => {
            const resType = member.genderId === choiceApi.GENDER_FEMALE ? choiceApi.RESERVATION_TYPE_FEMALE : choiceApi.RESERVATION_TYPE_MALE;
            typeList.push({ value: resType, text: member.nickname });
        })
    }

    return(typeList);
}


export function getOpList(status) {

    switch(status) {
        case choiceApi.RESERVATION_STATUS_NONE:
            return [
                { value: choiceApi.RESERVATION_STATUS_NONE, text: "Cancel" },
                { value: choiceApi.RESERVATION_STATUS_PENDING, text: "Requested" },
            ]

        case choiceApi.RESERVATION_STATUS_PENDING:
            return [
                { value: choiceApi.RESERVATION_STATUS_CANCELED, text: "Cancel" },
                { value: choiceApi.RESERVATION_STATUS_PENDING, text: "Requested" },
            ]

        case choiceApi.RESERVATION_STATUS_CONFIRMED:
            return [
                { value: choiceApi.RESERVATION_STATUS_CANCELED, text: "Cancel" },
                { value: choiceApi.RESERVATION_STATUS_CONFIRMED, text: "Cumming" },
            ]

        case choiceApi.RESERVATION_STATUS_CANCELED:
            return [
                { value: choiceApi.RESERVATION_STATUS_CANCELED, text: "Canceled" },
                { value: choiceApi.RESERVATION_STATUS_PENDING, text: "Requested" },
            ]

        case choiceApi.RESERVATION_STATUS_NO_SPACE:
            return [
                { value: choiceApi.RESERVATION_STATUS_NO_SPACE, text: "No Space" },
            ]

        case choiceApi.RESERVATION_STATUS_PREPAID:
            return [
                // { value: choiceApi.RESERVATION_STATUS_CANCELED, text: "Cancel" },
                { value: choiceApi.RESERVATION_STATUS_PREPAID, text: "Prepaid" },
            ]

        default: return []
    }

}



function ConfirmCovidWaiver({
    covidAck,
    setCovidAck,
    onComplete,
}) {

    if (covidAck) {
        return null;
    }

    function onDecline() {
        onComplete(false);
    }

    function onAccept() {
        setCovidAck(new Date().toISOString().split('T')[0]);
    }

    return (
        <Modal show={true} onHide={onDecline}>
            <Modal.Header closeButton closeVariant='white'>
                <Modal.Title>Covid Waiver Acknowledgement</Modal.Title>
            </Modal.Header>
            <Modal.Body className="waiver-dialog">
                {waiver}
            </Modal.Body>
            <Modal.Footer>
                <div className="d-flex justify-content-between w-100">
                    <div>
                        <a href={process.env.PUBLIC_URL + '/pdf/waiver.pdf'}>
                            <Button variant="outline-secondary">
                                <BootstrapIcon icon="file-pdf" /> Print  
                            </Button>
                        </a>
                    </div>
                    <div>
                        <Button variant="outline-secondary" onClick={onDecline}>
                            Decline
                        </Button>
                        <Button className="ms-2" variant="primary" onClick={onAccept}>
                            Accept
                        </Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );    
}


export function ReservationOps({
    basePath = '',
    statusId,
    onChange
}) {
    const opList = getOpList(statusId);

    return (
        <Row>
            <Col className="chip-row">
                {
                    opList.map((x) =>
                        <Radio key={x.value} name={`${basePath}/statusId`} id={`${basePath}/statusId/${x.value}`} value={x.value} title={x.text} onChange={onChange} />
                    )
                }
            </Col>
        </Row>
    );
}


function AttendingAs({
    typeList
}) {

    if (typeList.length <= 1) {
        return null
    }

    return <>
        <Row className="mt-2">
            <Col>
                Attending As
            </Col>
        </Row>
        <Row>
            <Col className="chip-row">
                {
                    typeList.map((x) =>
                        <Radio key={x.value} name="/typeId" id={`type${x.value}`} value={x.value} title={x.text} />
                    )
                }
            </Col>
        </Row>
    </>
}


const prepayTooltip = (props) => (
    <Popover id="prepay" {...props}>
        <Popover.Header>Prepay Info</Popover.Header>
        <Popover.Body>
        </Popover.Body>
    </Popover>
);

// TODO: this needs to provide a refresh function to the guests control and should load its own record
export function EditReservation() {
    const [ saving, setSaving ] = useState(false);
    const [ showPrepay, setShowPrepay ] = useState(false);

    //const navigate = useNavigate();
    const { event, reservation, onComplete, covidAck, setCovidAck } = useOutletContext();
    let { user } = useAuth();

    const formRef = useRef(null);

    const typeList = useMemo(() => getTypeList(user), [user]);

    useEffect(() => {
        if (reservation?.id === null && formRef.current) {
            formRef.current.setVal("/statusId", choiceApi.RESERVATION_STATUS_PENDING)
            formRef.current.setVal("/typeId", typeList[0].value)
        }
    }, [reservation, typeList])


    // any blank rows, we can eliminate
    // any blank fields, we need to alert the user that they are missing information
    const onSubmit = async (fields) => {
        setSaving(true);

        //
        // Check to make sure the fields are completed.  
        //  Guests must have a first and last name unless they are canceled
        //
        const validRequest = fields.guests.reduce((acc, x) => 
            acc && (x.statusId === choiceApi.RESERVATION_STATUS_CANCELED || ((x.firstName.length > 0) && (x.lastName.length > 0))) 
        , true)

        if (!validRequest) {
            alert('All guests must have a first and last name')
            setSaving(false);
            return;
        }

        if (reservation.id) {
            await choiceApi.saveReservation({...reservation, ...fields})
        }
        else {
            await choiceApi.createReservation({ ...reservation, ...fields, waiverSigned: covidAck })
        }
        setSaving(false);
        onComplete(true);
    }

    const handleCancelMember = async(e) => {
        if (e.target.value === choiceApi.RESERVATION_STATUS_CANCELED) {
            const rec = formRef.current.getAll();
            const updatedGuests = rec.guests.map((x) => ({...x, statusId: choiceApi.RESERVATION_STATUS_CANCELED}));
            formRef.current.onChangeSetVal('/guests', updatedGuests);
        }
    }


    const dateStr = event ? eventDateString(event) : null;
    const markup = event ? eventMarkup(event) : null;

    // const cancelChanges = () => {
    //     onComplete(false);
    // }

    // const prompt = {
    //     function: usePrompt,
    //     message: "You have unsaved changes.  Do you want to abandon them?",
    // }

    const membersResStatus = reservation?.statusName ?? "Not created yet";

    if (!reservation) return null;


    return(
        <Form className="ifta-form" initial={reservation} getList={choiceApi.getLookup} ref={formRef} >
            <Offcanvas className="edit-event" placement="end" show={true} >
                <Offcanvas.Header onHide={() => onComplete(false)} closeVariant="white" closeButton>
                    <Offcanvas.Title>
                        <div className="event-title">{event?.title}</div>
                        <div className="event-date">{dateStr}</div>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <ConfirmCovidWaiver covidAck={covidAck ?? reservation.waiverSigned} setCovidAck={setCovidAck} onComplete={onComplete} />
                

                    <Row>
                        <Col>
                            Member Reservation: <b><span>{membersResStatus}</span></b>
                        </Col>
                    </Row>

                    <ReservationOps statusId={reservation.statusId} onChange={handleCancelMember} />

                    <AttendingAs typeList={typeList} />

                    <Guests name="/guests" eventAllowGuests={event.allowGuests} />
                    
                    <Row className="pt-5">
                        <Col>
                            <h2>Event Details</h2>
                        </Col>
                    </Row>

                    <Row>
                        <Col className="event-icon">
                            <img src={`/event_icons/${event?.icon}`} alt="event icon" />
                        </Col>
                    </Row>

                    <Row>
                        <Col className="event-icon">
                            <span className="event-desc" dangerouslySetInnerHTML={{ __html: markup }} />
                        </Col>
                    </Row>


                </Offcanvas.Body>
                <div className="edit-event-footer">
                    <Row className="my-1">
                        <Col xs={12} className="text-end">
                            <u onClick={() => setShowPrepay(!showPrepay)}><small>How do I prepay <BootstrapIcon icon={showPrepay ? "x-lg" : "question-circle"} /></small></u>
                            <Collapse in={showPrepay}>
                                <p className="text-start">
                                    <b>Call (401-274-3700) between the hours of 10a - 5p MONDAY through FRIDAY to schedule prepay</b>. Your card will not be charged until Saturday afternoon. Please cancel your reservation online by Saturday morning, if necessary, to avoid being charged. <b>We cannot take calls during the day on Saturday's</b>, so please make sure to call during the week.
                                </p>
                            </Collapse>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} className="text-end">
                            <FormReset as={Button} onClick={() => onComplete(false)} variant="outline-secondary">
                                Go Back
                            </FormReset>

                            <FormSubmit
                                as={Button}
                                disabled={saving}
                                onClick={onSubmit}
                                variant={"outline-primary"}
                                dirty={{ variant: "primary" }}
                            >
                                Save Changes
                            </FormSubmit>
                        </Col>
                    </Row>
                </div>

            </Offcanvas>
        </Form>
    )
}
